@if (loading) {
    <div class="w-full h-full mt-8">
        <app-loader [withBackground]="false" variant="secondary" [width]="80"></app-loader>
    </div>
}
<div class="block" [style.width]="(isMobile$ | async) ? '100%' : '80%'" [innerHTML]="htmlStr"></div>

